import React from 'react';
import { ContentHeading } from '../../CommunityPage/MainContent/styled';
import CategoryBanner from '../CategoryBanner';
import CategoryUserFeed from '../CategoryUserFeed';
import RelatedArticles from '../../ArticlePage/RelatedArticles';

export default function OldTopicDetail(props) {
  let { itemsArray, tagId, stage, relatedArticlesContent, tagData } = props;
  return (
    <>
      <ContentHeading>{tagData[0]?.description}</ContentHeading>
      <CategoryBanner />
      {/* <ContentTypeSelector /> */}
      <CategoryUserFeed
        itemsArray={itemsArray}
        tagId={tagId}
        stage={stage}
        sectionName={''}
      />
      <RelatedArticles
        title={'MORE TOPICS FOR YOU'}
        data={relatedArticlesContent}
      />
    </>
  );
}
